import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/trainings/lib/My_trainingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
